import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Question = styled.h4`
  color: ${props => props.theme.secondaryColor};
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  &:hover {
    color: #000;
    cursor: pointer;
  }
`;

const Answer = styled.div`
  display: none;
  margin-bottom: 2rem;
  color: ${props => props.theme.lightGreyText};
`;
/**
 *  A simple FAQ compnent which displays a Question as a title and on click will show the answer
 */
class Faq extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false
    };
  }

  toggleDetails = () => {
    this.setState({
      showDetails: !this.state.showDetails
    });
  };

  render() {
    const detailsActive = this.state.showDetails ? 'show' : '';

    return (
      <>
        <Question
          onClick={this.toggleDetails}
          dangerouslySetInnerHTML={{ __html: this.props.question }}
        />
        <Answer className={`${detailsActive}`}>
          <div dangerouslySetInnerHTML={{ __html: this.props.answer }} />
        </Answer>
      </>
    );
  }
}

Faq.propTypes = {
  /**
   * Passes a question for an FAQ in string format - Sourced in DatoCMS */
  question: PropTypes.string,
  /**
   * Passes and answer for an FAQ in a string format - Sourced in DatoCMS
   */
  answer: PropTypes.string
};

export { Faq };
